import useSWR from 'swr'

import { get } from 'lib/network/fetchers/everlane'
import { getDistanceFromUser } from 'lib/helpers/localization'
import ApiError from 'lib/network/ApiError'
import useSession from 'lib/network/hooks/useSession'
import Storefront from 'types/Storefront'

const useStorefronts = (visitorLatLong: string) => {
  const { data: session } = useSession()

  const { data, ...result } = useSWR<{ storefronts: Storefront[] }, ApiError>(
    session ? '/api/v2/storefronts' : null,
    path => get(path, { inventory_only: true }),
    { revalidateOnFocus: false },
  )

  const sortedStorefronts = data?.storefronts
    ?.map(store => {
      const distanceFromUser = getDistanceFromUser({
        latitude: store.latitude,
        longitude: store.longitude,
        visitorLatLong,
      })
      return { ...store, distanceFromUser }
    })
    .sort((a, b) => {
      return a.distanceFromUser - b.distanceFromUser
    })

  return { data: sortedStorefronts, ...result }
}

export default useStorefronts
